import { requestBase, requestFactory } from '@/plugins/axios'
// {productId}
export function fetchData(params) {
    return requestBase({
          url: 'v1/factory/product-order/find/id',
          method: 'GET',
          params: params
        })
}
export function getEquipData(data) {
      return requestFactory({
            url: 'machine/findById',
            method: 'POST',
            data: data
      })
}
export function getCreatorInfo(workerId) {
      return requestBase({
            url: 'v1/factory/worker/find/id',
            method: 'get',
            params: { workerId }
      })
}
